/** Generated by syncRemoteAssets.js - DO NOT EDIT */
import data from './Google_Services.json';
export default data;
